import {
  utils,
} from '@ama-sdk/core';
import {
  createFlight,
  MockFlight,
  todayPlusNdays,
} from '@dapi/sdk/spec';



export const cabin = 'eco';
export const fareFamilyCode = 'AUBZSAVE';
export const statusCode = 'HK';

export const flight: MockFlight = createFlight({ template: { marketingFlightNumber: '6312' } });
export const flightSecure: MockFlight = createFlight({ template: { secureFlightIndicator: true } });

export const flightOutBoundInt: MockFlight = {
  marketingAirline: 'TX',
  marketingAirlineCode: 'TX',
  operatingAirlineCode: 'TX',
  operatingAirline: 'TX',
  marketingFlightNumber: '648',
  operatingAirlineFlightNumber: '648',
  departure: {
    locationCode: 'ORY',
    dateTime: new utils.DateTime(todayPlusNdays('09:00', 5)),
    terminal: '4'
  },
  arrival: {
    locationCode: 'CUN',
    dateTime: new utils.DateTime(todayPlusNdays('15:00', 5)),
    terminal: '3'
  },
  aircraftCode: '333',
  duration: 39900,
  isOpenSegment: false,
  isInformational: false,
  secureFlightIndicator: false,
  meals: { bookingClass: 'Z', mealCodes: ['M', 'S'] },
  flightStatus: 'scheduled',
  aircraftConfigurationVersion: 'AY8'
};

export const flightInBoundInt = {
  marketingAirlineCode: 'TX',
  operatingAirlineCode: 'TX',
  marketingFlightNumber: '649',
  operatingAirlineFlightNumber: '649',
  marketingAirline: 'TX',
  operatingAirline: 'TX',
  departure: {
    locationCode: 'CUN',
    dateTime: new utils.DateTime(todayPlusNdays('09:00', 15)),
    terminal: '3'
  },
  arrival: {
    locationCode: 'ORY',
    dateTime: new utils.DateTime(todayPlusNdays('12:00', 15)),
    terminal: '4'
  },
  aircraftCode: '359',
  duration: 35400,
  isOpenSegment: false,
  isInformational: false,
  secureFlightIndicator: false,
  meals: {
    bookingClass: 'N',
    mealCodes: [
      'M',
      'S'
    ]
  },
  flightStatus: 'scheduled',
  aircraftConfigurationVersion: '350'
};

export const flightOutBoundDom: MockFlight = {
  marketingAirline: 'TX',
  marketingAirlineCode: 'TX',
  operatingAirlineCode: 'TX',
  operatingAirline: 'TX',
  marketingFlightNumber: '304',
  operatingAirlineFlightNumber: '304',
  departure: { locationCode: 'PTP',
    dateTime: new utils.DateTime(todayPlusNdays('09:00', 5)),
    terminal: '2' },
  arrival: {locationCode: 'FDF',
    dateTime: new utils.DateTime(todayPlusNdays('15:00', 5)),
    terminal: '1' },
  aircraftCode: 'AT6',
  duration: 2700,
  isOpenSegment: false,
  isInformational: false,
  secureFlightIndicator: false,
  meals: { bookingClass: 'E', mealCodes: [ 'H' ] },
  flightStatus: 'cancelled'
};
export const flightInBoundDom: MockFlight = {
  ...flightOutBoundDom,
  departure: {
    locationCode: 'FDF',
    dateTime: new utils.DateTime(todayPlusNdays('09:00', 15)),
    terminal: '2'
  },
  arrival: {
    locationCode: 'PTP',
    dateTime: new utils.DateTime(todayPlusNdays('15:00', 15)),
    terminal: '1'
  }
};

export const flightOutBoundVisual: MockFlight = {
  ...flightOutBoundDom,
  departure: {
    locationCode: 'PTP',
    dateTime: new utils.DateTime('2025-01-20T13:14:38.179')
  },
  arrival: {
    locationCode: 'FDF',
    dateTime: new utils.DateTime('2025-01-20T15:14:38.179'),
    terminal: '1'
  }
};

export const flightInBoundVisual: MockFlight = {
  ...flightInBoundDom,
  departure: {
    locationCode: 'FDF',
    dateTime: new utils.DateTime('2025-01-25T15:14:38.179')
  },
  arrival: {
    locationCode: 'PTP',
    dateTime: new utils.DateTime('2025-01-25T17:14:38.179'),
    terminal: '1'
  }

};
